<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false"
      :title="!parent ? 'Modification d\'une Origine' : 'Modification d\'une sous-origine'">
    </page-nav-bar>
    <page-content
      :has-no-padd-on-act-on-desktop="false"
      :set-main-col-class="'is-12 is-9-widescreen is-8-fullhd'">
      <div class="has-background-white is-border">
        <origin-form
          v-if="origin && !loading"
          @submit="editOrigin"
          :source="origin"
          :parent="parent"
          :loading="loading"
          :submit-loading="submitLoading"></origin-form>
      </div>
    </page-content>
  </div>
</template>

<script>
export default {
  name: 'OriginEdit',
  components: {
    OriginForm: () => import('@/components/origin/OriginForm')
  },
  data () {
    return {
      loading: true,
      submitLoading: false,
      parent: null,
      origin: null
    }
  },
  computed: {
    originPk () {
      return this.$route.params.id
    },
    parentPk () {
      return this.$route.query.parent
    }
  },
  created () {
    this.getOrigin(this.originPk)
    if (this.parentPk) {
      this.getParentOrigin(this.parentPk, true)
    }
  },
  methods: {
    async getOrigin (id, parent = false) {
      this.loading = true
      try {
        let { data } = await this.$api.getOne(this.$resources.ORIGIN, id)
        if (parent) {
          this.parent = data
          this.loading = false
        } else {
          this.origin = data
          if (this.origin.parent) {
            this.getOrigin(this.origin.parent.pk, true)
          } else {
            this.loading = false
          }
        }
      } catch (err) {
        this.loading = false
        console.log(err)
      }
    },
    async editOrigin (origin) {
      this.submitLoading = true
      if (origin.parent && 'pk' in origin.parent) {
        origin.parent = origin.parent.pk
      }
      try {
        let { data } = await this.$api.put(this.$resources.ORIGIN, this.originPk, origin)
        this.submitLoading = false
        if (data.parent) {
          this.$router.replace({ name: 'OriginVue', params: { id: data.parent.pk } })
        } else {
          this.$router.replace({ name: 'OriginVue', params: { id: data.pk } })
        }
      } catch (err) {
        console.log(err)
        this.submitLoading = false
      }
    }
  }
}
</script>
